import { authFetch } from './authFetch';

function getBaseUrl() {
  return `${window.REACT_APP_API_ENDPOINT}/api/actuaciones-reforma`;
}

console.log('BASE_URL', getBaseUrl());

export const getAllActuaciones = (collectionId) => {
  if (collectionId) {
    return authFetch(`${getBaseUrl()}?coleccion_id=${collectionId}`);
  }
  return authFetch(getBaseUrl());
};
export const getActuacionById = (id) => authFetch(`${getBaseUrl()}/${id}`);
export const createActuacion = (data) => authFetch(getBaseUrl(), {
    method: 'POST',
    body: JSON.stringify(data)
});
export const updateActuacion = (id, data) => authFetch(`${getBaseUrl()}/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
});
export const deleteActuacion = (id) => authFetch(`${getBaseUrl()}/${id}`, {
    method: 'DELETE'
});
export const getAllCollections = () => authFetch(`${getBaseUrl()}/colecciones`);
export const getCollectionById = (id) => authFetch(`${getBaseUrl()}/colecciones/${id}`);
export const createCollection = (data) => authFetch(`${getBaseUrl()}/colecciones`, {
  method: 'POST',
  body: JSON.stringify(data)
});
export const updateCollection = (id, data) => authFetch(`${getBaseUrl()}/colecciones/${id}`, {
  method: 'PUT',
  body: JSON.stringify(data)
});
export const getAllTiposReforma = () => authFetch(`${getBaseUrl()}/tipos-reforma`);
export const getAllUnidades = () => authFetch(`${getBaseUrl()}/unidades`); 